class Component {
    constructor(apiConfig, http) {
        const { siteInfo } = apiConfig;
        const { storeId } = siteInfo;
        this.apiConfig = apiConfig;
        this.http = http;
        this.path = `/wcs/resources/store/${storeId}/component`;
    }

    get(template, componentKey, params, config) {
        return this.http(`${this.path}/${template}/${componentKey}`, { params, method: 'get', ...config }).then(
            resp => {
                const { data, status } = resp;
                //attempt to parse response
                if (status === 200 && data && data !== '') {
                    return data;
                } else {
                    return Promise.reject({});
                }
            }
        );
    }

    getAnalyticsData(template, vanityUrl, config) {
        return this.get('analytics', template, { path: vanityUrl }, config);
    }

    getAddToCartPopup(vanityUrl, config) {
        return this.get('product', 'atcpopup', { path: vanityUrl }, config);
    }
}

export default Component;
